<template>
  <InfuseSlideInLayout :title="chargingStation?.name" :parent-to="{ name: 'charging-stations' }">
    <template #header>
      <h1 class="text-xl font-bold text-neutral-700">
        <span>{{ chargingStation?.name }}</span>

        <InfuseTag v-if="chargingStation?.ocppVersion" :inline="true" class="ml-4 font-medium" variant="neutral">
          <font-awesome-icon :icon="['fal', 'signal-stream']" class="mr-2" />
          OCPP-{{ chargingStation?.ocppVersion }}
        </InfuseTag>

        <InfuseTag v-if="chargingStation?.type" :inline="true" class="ml-4 font-medium" variant="neutral">
          <font-awesome-icon :icon="['fal', 'ethernet']" class="mr-2" />
          {{ chargingStation?.type }}
        </InfuseTag>
      </h1>
    </template>

    <InfuseRouterTabLayout v-if="chargingStation" :model="chargingStation" @reload-model="refresh" />
    <InfuseSpinner v-else class="flex items-center justify-center p-16" size="medium" />
  </InfuseSlideInLayout>
</template>

<script setup lang="ts">
import { InfuseSpinner, InfuseTag } from '@infuse/ui/components';
import { InfuseRouterTabLayout, InfuseSlideInLayout } from '@infuse/ui/layouts';
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useRedirectOnNotFound } from '@infuse/e-connector/shared/composables';
import { useChargingStation } from '@infuse/e-connector/charging-station/queries';

const route = useRoute();
const id = computed(() => route.params.id?.toString());

const { chargingStation, fetchChargingStationId, isError, error, refetch } = useChargingStation();
useRedirectOnNotFound(isError, error);

watch(id, () => (fetchChargingStationId.value = id.value), { immediate: true });

async function refresh() {
  await refetch();
}
</script>
